import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ark-account-configuration',
  templateUrl: './account-configuration.component.html',
  styleUrls: ['./account-configuration.component.scss']
})
export class AccountConfigurationComponent implements OnInit {

  subject: string;
  activation: boolean;

  constructor(
    public dialogRef: MatDialogRef<AccountConfigurationComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.subject = this.data.subject;
    this.activation = this.data.activation;
  }

  close(flag = false) {
    this.dialogRef.close(flag);
  }
}
